export default __webpack_public_path__ + "static/media/au-photo.64587160.jpg";